import { Grid, Typography } from "@mui/material"
import { makeStyles } from "@mui/styles"

export default function ComparisonCard({
    value,
    title,
    description,
    old = false,
    added = false,
    placeholder = false,
}){

    const classes = useStyles()

    return(

        <>
            <div
                className={`${classes.cardWrapper} revalida`}
                style = {{
                    background: placeholder ? '#191D1C' : old ? '#333' : 'linear-gradient(90deg, #47E4A6 0%, #4CCEDD 100%)',
                }}
            >
                <div
                    className={classes.card}
                    style = {{
                        backgroundColor: placeholder ? '#191D1C' : '#262626',
                    }}
                >
                    <Grid
                        direction={'row'}
                        item
                        container
                        justifyContent={'center'}
                        alignItems={'center'}
                    >
                        <Typography
                            className={`${classes.title}`}
                            fontFamily={'Manrope'}
                            justifyContent={'center'}
                        >
                            {!!value && (
                                <span
                                    className={`gradient-text`}
                                    style={{
                                        fontSize: '18px !important',
                                        fontWeight: 600,
                                    }}
                                >
                                    {value}
                                    &nbsp;
                                </span>
                            )}

                            {title}
                        </Typography>
                    </Grid>

                    {!!description && (
                        <Grid>
                            <Typography
                                className={`${classes.description}`}
                                fontFamily={'Manrope'}
                            >
                                {description}
                            </Typography>
                        </Grid>
                    )}
                </div>
            </div>
        </>

    )

}

const useStyles = makeStyles((theme) => ({
    cardWrapper: {
        position: 'relative',
        width: '100%',
        minHeight: '61px',
        padding: '1px',
        borderRadius: '16px',
        
    },
    card: {
        width: '100%',
        height: '100%',
        padding: '16px 24px !important',
        borderRadius: '16px',
    },
    title: {
        display: 'inline-flex',
        flexWrap: 'wrap',
        // width: '100% !important',
        color: '#fff',
        fontSize: '18px !important',
        fontWeight: 600,
        textAlign: 'center',
    },
    description: {
        width: '100% !important',
        color: '#B3B3B3',
        fontSize: '14px !important',
        textAlign: 'center',
    },
}))